import HttpClient from "./HttpClient";
import Order from "./Order";
import WorkCenterDependency from "./WorkCenterDependency";

export default class WorkCenter {
  constructor(center) {
    this.id = center.id;
    this.code = center.code;
    this.description = center.description;
    this.max_load = center.max_load;
    this.company_id = center.company_id;
    this.created_at = center.created_at;
    this.updated_at = center.updated_at;
    this.probability = center.probability;
    this.dependencies = this.getDependencies(center.dependencies);
    this.deleted = center.deleted;
    this.preperation = center.preperation;
  }

  static async create(data) {
    const client = new HttpClient();
    const response = await client.instance.post(`work-centers`, data);
    return response.data;
  }

  async save() {
    const client = new HttpClient();
    const response = await client.instance.put(`work-centers/${this.id}`, this);
    return response.data;
  }

  getDependencies(dependencies) {
    const workCenterDependencies = [];
    dependencies.forEach(dependency => {
      workCenterDependencies.push(new WorkCenterDependency(dependency));
    });
    return workCenterDependencies;
  }

  toString() {
    return `${this.code} - ${this.description}`;
  }

  static async loadWorkCenterPlan(centerId, oldOrders, filter, finished, page, preperation) {
    if (!centerId) return;
    const client = new HttpClient();
    const response = await client.instance.get(`work-centers/${centerId}`, {
      params: {
        filter: filter,
        finished: finished,
        page: page
      }
    });
    const orders = Order.getExpandedOrders(response.data.orders, oldOrders);
    const pages = response.data.pages;
    orders.sort((a, b) => {
      //gets dates of expected soonest products
      const dateA = preperation ? new Date(a.delivery_date) : new Date(a.completion_date);
      const dateB = preperation ? new Date(b.delivery_date) : new Date(b.completion_date);
      //get oldest first
      return dateA.getTime() - dateB.getTime();
    });
    return { orders, pages };
  }

  static async loadCenters(withDeleted) {
    const client = new HttpClient();
    const response = await client.instance.get("work-centers");
    let centers = [];
    response.data.forEach(center => {
      centers.push(new WorkCenter(center));
    });
    centers = WorkCenter.getLevel(centers);
    centers.sort((a, b) => {
      if (a.level < b.level) { return -1; }
      if (a.level > b.level) { return 1; }
      if (a.code < b.code) { return -1; }
      if (a.code > b.code) { return 1; }
      return 0;
    });
    return centers.filter(workCenter => {
      if (withDeleted) {
        return 1;
      }
      return workCenter.deleted == 0;
    });
  }

  /**
   * finds the length of the longest dependency chain
   * @param {array} centers 
   */
  static getLevel(centers) {
    centers.forEach(center => {
      center.level = 0;
    });
    let cycles = 0;
    let changed = true;
    while (changed) {
      if (cycles > 30) {
        break;
      }
      changed = false;
      cycles++;
      centers.forEach(center => {
        center.dependencies.forEach(dependency => {
          const dependencyCenter = centers.find(center => {
            return center.id === dependency.depends_on;
          });
          if (dependencyCenter.level + 1 > center.level) {
            center.level = dependencyCenter.level + 1;
            changed = true;
          }
        });
      });
    }
    return centers;
  }
}
